import { clientAuthorizedGet } from 'utils/fetchUtils';
import { API_ROUTES } from 'utils/constants';
import type { Supplier } from 'types/supplier';
import type { ContactGroup } from 'types/contactGroup';
import type { PaginatedResponse } from 'types/pagination';

export const SUPPLIERS_LIST_PAGE_SIZE = 10;

export type SuppliersListQueryParams = {
  page: number;
  limit: number;
  search: string;
  includeVoided: boolean;
  includeGroupIds: string;
  excludeGroupIds: string;
};

export const suppliersListQueryKeys = {
  all: ['suppliers-list'] as const,
  groups: (companyId: string) =>
    [...suppliersListQueryKeys.all, 'groups', companyId] as const,
  page: (companyId: string, params: SuppliersListQueryParams) =>
    [
      ...suppliersListQueryKeys.all,
      'page',
      companyId,
      params.page,
      params.limit,
      params.search,
      params.includeVoided,
      params.includeGroupIds,
      params.excludeGroupIds,
    ] as const,
};

function buildSuppliersListRequestParams(
  params: SuppliersListQueryParams,
): Record<string, string> {
  const query: Record<string, string> = {
    page: String(params.page),
    limit: String(params.limit),
    search: params.search,
    includeVoided: String(params.includeVoided),
  };
  if (params.includeGroupIds) {
    query.includeGroupIds = params.includeGroupIds;
  }
  if (params.excludeGroupIds) {
    query.excludeGroupIds = params.excludeGroupIds;
  }
  return query;
}

export async function fetchSuppliersListPage(
  companyId: string,
  params: SuppliersListQueryParams,
): Promise<PaginatedResponse<Supplier>> {
  return clientAuthorizedGet<PaginatedResponse<Supplier>>(
    API_ROUTES.SUPPLIERS,
    buildSuppliersListRequestParams(params),
    companyId,
  );
}

export async function fetchSupplierGroupsList(
  companyId: string,
): Promise<ContactGroup[]> {
  return clientAuthorizedGet<ContactGroup[]>(
    API_ROUTES.SUPPLIER_GROUPS,
    {},
    companyId,
  );
}
